import SlideLayout from './SlideLayout';

export default function SectionSpotlight({ week, spots, onAskQuestion }) {
  if (!Array.isArray(spots) || spots.length === 0) return null;

  const eyebrow = week?.emoji ? `Spotlight · ${week.emoji}` : 'Spotlight';
  const title = week?.name || 'This week in your community';
  const intro = week?.header || null;
  const footer = 'Refreshed weekly by our editor — no work on your team.';

  return (
    <SlideLayout eyebrow={eyebrow} title={title} intro={intro} footer={footer}>
      <div className="grid gap-4 sm:grid-cols-3">
        {spots.map((spot, index) => (
          <button
            key={spot.answer_id || spot.label || index}
            type="button"
            onClick={() => onAskQuestion(spot.query, null)}
            className="group flex h-full flex-col gap-3 border border-tf-stone bg-tf-surface p-5 text-left transition-colors hover:border-tf-teal hover:bg-white sm:p-6"
          >
            <span className="text-2xl" aria-hidden="true">
              {spot.emoji || '✦'}
            </span>
            <p className="text-[16px] font-medium leading-[1.4] text-tf-ink sm:text-[17px]">
              {spot.label}
            </p>
            <p className="text-[14px] font-light leading-[1.6] text-tf-ink/70">{spot.query}</p>
            <span className="mt-auto inline-flex items-center gap-1 text-[12px] font-medium uppercase tracking-[0.12em] text-tf-teal-mid transition-transform group-hover:translate-x-0.5">
              Ask this question →
            </span>
          </button>
        ))}
      </div>
    </SlideLayout>
  );
}
